var PlannerService = /** @class */ (function () {
    function PlannerService(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * SearchDestinationsAsync
     * @param term
     * @param includeNearby Default: false (adds second array of destinations nearby if true)
     * @param limit Default: 30
     * @param fromIataCode Default: "" (will retrieve valid destinations of selected record)
     * @param includeInactive Default: false (if true, returns locations with LocAvrive = false)
     * @returns any Successful response
     * @throws ApiError
     */
    PlannerService.prototype.getApiV1PlannerAirportsSearch = function (term, includeNearby, limit, fromIataCode, includeInactive) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/planner/airports/search',
            query: {
                'term': term,
                'includeNearby': includeNearby,
                'limit': limit,
                'fromIataCode': fromIataCode,
                'includeInactive': includeInactive,
            },
        });
    };
    /**
     * GetDestinationsNearbyAsync
     * StartFragment
   *
   * This call is used to expose functionality using custom location coordinates. To allow MaxMind to detect the coordinates, don't specify any coordinates.
     * @param latitude
     * @param longitude Default: -1
     * @param limit Default: 30
     * @param fromIataCode Default: "" (will retrieve valid destinations of selected record)
     * @param includeInactive Default: false (if true, returns locations with LocAvrive = false)
     * @returns any Successful response
     * @throws ApiError
     */
    PlannerService.prototype.getApiV1PlannerAirportsNearby = function (latitude, longitude, limit, fromIataCode, includeInactive) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/planner/airports/nearby',
            query: {
                'latitude': latitude,
                'longitude': longitude,
                'limit': limit,
                'fromIataCode': fromIataCode,
                'includeInactive': includeInactive,
            },
        });
    };
    /**
     * GetFlightsAsync
     * @param originIataCode
     * @param departureDate Must be a DateTime compatible value that occurs on the current date
     * @param tripDuration Min: 1, Max: 360 (Trip duration in days)
     * @param rangeOfDeparture Default: 1, Min: 1, Max: 360 (Range of departure in days where the search is processed starting the departure date.)
     * @param durationFlexibility Default: 1 (Flexibility in days for the trip duration. Flexibility = 3 means +/- 3 days. If not specified, the search is taking into account the duration specified. If a flexibility n is specified, the search of trip recommendations applies to a trip duration from x-n days to x+n days)
     * @param destinationIataCode Default: ""
     * @returns any Successful response
     * @throws ApiError
     */
    PlannerService.prototype.getApiV1PlannerFlightsSearch = function (originIataCode, departureDate, tripDuration, rangeOfDeparture, durationFlexibility, destinationIataCode) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/planner/flights/search',
            query: {
                'originIataCode': originIataCode,
                'departureDate': departureDate,
                'tripDuration': tripDuration,
                'rangeOfDeparture': rangeOfDeparture,
                'durationFlexibility': durationFlexibility,
                'destinationIataCode': destinationIataCode,
            },
        });
    };
    /**
     * GetFlightContentAsync
     * @param originIataCode
     * @param rangeOfDeparture Default: NULL, Min: 1, Max: 360 (Range of departure in days where the search is processed starting the departure date. Will fall back to DealsLandingPage's settings if not provided)
     * @param tripDuration Default: NULL, Min: 1, Max: 360 (Trip duration in days. Will fall back to DealsLandingPage's settings if not provided)
     * @param durationFlexibility Default: NULL (Flexibility in days for the trip duration. Flexibility = 3 means +/- 3 days. If not specified, the search is taking into account the duration specified. If a flexibility n is specified, the search of trip recommendations applies to a trip duration from x-n days to x+n days Will fall back to DealsLandingPage's settings if not provided)
     * @returns any Successful response
     * @throws ApiError
     */
    PlannerService.prototype.getApiV1PlannerFlightsContent = function (originIataCode, rangeOfDeparture, tripDuration, durationFlexibility) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/planner/flights/content',
            query: {
                'originIataCode': originIataCode,
                'rangeOfDeparture': rangeOfDeparture,
                'tripDuration': tripDuration,
                'durationFlexibility': durationFlexibility,
            },
        });
    };
    return PlannerService;
}());
export { PlannerService };
